import * as React from 'react';

function IconPlus(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.545 7.2H8.88V2.533a.8.8 0 00-1.6 0V7.2H2.612a.8.8 0 100 1.6h4.667v4.667a.8.8 0 101.6 0V8.8h4.666a.8.8 0 100-1.6z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconPlus = React.memo(IconPlus);
export default MemoIconPlus;
